import { CONSTANTS } from 'config/constants';
import { LabConstuction } from 'models/order-input/lab-order';
import { AvailableConstructionProperties, ConstructionProperty } from 'models/property';
import { ScannerCase } from 'models/scanner-case';

const { UPPER_JAW, LOWER_JAW } = CONSTANTS;

export const extractTeethState = (teethStructure: { [key: string]: number }) => {
    return new Map(
        Object.entries(teethStructure)
            .filter(([k]) => !isNaN(Number(k))) // keep only numeric keys
            .map(([k, v]) => [Number(k), v]),
    );
};

export const emptyConstruction = (): LabConstuction => {
    return {
        teethNumbers: [],
        teethState: new Map(),
        actions: [],
        materials: [],
        warranty: false,
        isTioTandvard: false,
        warrantyType: '',
        properties: {} as ConstructionProperty,
        usedProperties: {} as AvailableConstructionProperties,
        isMaterialGridValid: true,
        isActionGridValid: true,
    };
};

export const extractScannerCaseTeethNumbers = (
    scannerCase: ScannerCase,
): { teethNumbers: number[]; teethState: Map<number, number> } => {
    const teeth = new Map<number, number>();
    if (scannerCase?._id) {
        scannerCase.restorations.forEach((restoration) => {
            let restorationTeeth: number[] = [];
            if (restoration.teethNumbers && restoration.teethNumbers.length > 0) {
                restorationTeeth = restoration.teethNumbers;
            } else if (restoration.jaw) {
                if (restoration.jaw === 'UPPER_JAW') {
                    restorationTeeth = UPPER_JAW.map((num) => parseInt(num.toString()));
                } else if (restoration.jaw === 'LOWER_JAW') {
                    restorationTeeth = LOWER_JAW.map((num) => parseInt(num.toString()));
                } else if (restoration.jaw === 'BOTH_JAWS') {
                    restorationTeeth = [...UPPER_JAW, ...LOWER_JAW].map((num) => parseInt(num.toString()));
                }
            }
            restorationTeeth.forEach((tooth) => {
                teeth.set(tooth, restoration.product?.toLowerCase().includes('pontic') ? 2 : 1);
            });
        });
    }
    return {
        teethNumbers: teeth.size > 0 ? Array.from(teeth.keys()) : [],
        teethState: teeth,
    };
};

export type CurrencyValidation = {
    isValid: boolean;
    errorKey?: 'ACTION_CURRENCY_MISSING' | 'ACTION_MATERIAL_CURRENCY_MISMATCH';
    values?: { actionCurrency: string; materialCurrency: string };
};

// An order is priced in one currency, so the action and material price data must agree and the
// action side must resolve at all. undefined = price data not loaded yet (block Next quietly);
// null = loaded, and the clinic has set no currency.
export const getCurrencyValidation = (order: {
    actionCurrency?: string | null;
    materialCurrency?: string | null;
}): CurrencyValidation => {
    if (order.actionCurrency === undefined) {
        return { isValid: false };
    }
    if (order.actionCurrency === null) {
        return { isValid: false, errorKey: 'ACTION_CURRENCY_MISSING' };
    }
    if (order.materialCurrency && order.materialCurrency !== order.actionCurrency) {
        return {
            isValid: false,
            errorKey: 'ACTION_MATERIAL_CURRENCY_MISMATCH',
            values: { actionCurrency: order.actionCurrency, materialCurrency: order.materialCurrency },
        };
    }
    return { isValid: true };
};
